module.exports = __webpack_public_path__ + "static/media/1_pl.67f3a813.png";